import { fullTime, pointTime, relativeTime } from '../lib/format';

interface ITimeProps {
  iso: string;
  now: number;
  timeZone?: string;
  className?: string;
}

// 00-rules: the clock time in text, the relative one only on hover, and the zone always there.
export const Time = ({ iso, now, timeZone, className }: ITimeProps) => (
  <time
    dateTime={iso}
    title={`${fullTime(iso, timeZone)} · ${relativeTime(iso, now, timeZone)}`}
    className={className}
  >
    {pointTime(iso, now, timeZone)}
  </time>
);
